import { useFormikContext } from "formik";
import { FormControl, Form, Stack } from "react-bootstrap";
import { ErrorText } from "../../../../@ui/ErrorText";
import { BannerMessageRequest } from "../../../../types/BannerMessage/BannerMessageCreateRequest";
import { BannerMessageFormModel } from "../../../../types/BannerMessage/BannerMessageForm";
import TimeInput from "../../../../form/time/timeInput";
import styled from "styled-components";

const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  width: 100%;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

const BannerMessageForm = () => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    useFormikContext<BannerMessageFormModel>();

  return (
    <Stack gap={3}>
      <Form.Group>
        <Form.Label>Message</Form.Label>
        <FormControl
          type="text"
          name="message"
          value={values.message}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {errors.message && touched.message && (
          <ErrorText className="text-danger px-1">{errors.message}</ErrorText>
        )}
      </Form.Group>
      <Form.Group>
        <Form.Label>Display From</Form.Label>
        <TimeContainer>
          <div className="d-flex flex-column w-50 gap-1">
            <Form.Control
              type="date"
              name="displayFromDate"
              value={values.displayFromDate || ""}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.displayFromDate && touched.displayFromDate && (
              <ErrorText className="text-danger px-1">
                {errors.displayFromDate}
              </ErrorText>
            )}
          </div>
          <div className="d-flex flex-column w-50 gap-1">
            <TimeInput
              name="displayFromTime"
              value={values.displayFromTime || ""}
              hasError={!!errors.displayFromTime}
              onChange={(value: string) =>
                setFieldValue("displayFromTime", value)
              }
              onBlur={handleBlur}
            />
            {errors.displayFromTime && touched.displayFromTime && (
              <ErrorText className="text-danger px-1">
                {errors.displayFromTime}
              </ErrorText>
            )}
          </div>
        </TimeContainer>
      </Form.Group>
      <Form.Group>
        <Form.Label>Display To</Form.Label>
        <TimeContainer>
          <div className="d-flex flex-column w-50 gap-1">
            <Form.Control
              type="date"
              name="displayToDate"
              value={values.displayToDate || ""}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.displayToDate && touched.displayToDate && (
              <ErrorText className="text-danger px-1">
                {errors.displayToDate}
              </ErrorText>
            )}
          </div>

          <div className="d-flex flex-column w-50 gap-1">
            <TimeInput
              name="displayToTime"
              value={values.displayToTime || ""}
              hasError={!!errors.displayToTime}
              onChange={(value: string) =>
                setFieldValue("displayToTime", value)
              }
              onBlur={handleBlur}
            />
            {errors.displayToTime && touched.displayToTime && (
              <ErrorText className="text-danger px-1">
                {errors.displayToTime}
              </ErrorText>
            )}
          </div>
        </TimeContainer>
      </Form.Group>
    </Stack>
  );
};

export default BannerMessageForm;
